import styled from "styles/styled_components";

const StyledLoaderOverlay = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.bgLight};
  color: ${(props) => props.theme.colors.brandGray30};
  display: flex;
  flex-direction: column;
  font-size: ${(props) => props.theme.text.size.large};
  height: 100vh;
  justify-content: center;
  padding-bottom: 20vh;
  z-index: ${(props) => props.theme.layering.overlay};
`;

export default StyledLoaderOverlay;
